import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Products from '../frontend/components/Products';
import Header from '../frontend/components/Header';
import Footer from '../frontend/components/Footer';
import PlanCategories from '../frontend/components/PlanCategories';
const Plans = () => {
  const [billingCycle, setBillingCycle] = useState('monthly');

  const plans = [
    {
      name: 'Starter',
      price: { monthly: 49, yearly: 490 },
      desc: 'Perfect for small businesses getting started',
      features: ['Up to 50 members', 'Basic claims processing', 'Email support', 'API access', 'Standard reporting'],
      popular: false
    },
    {
      name: 'Professional',
      price: { monthly: 149, yearly: 1490 },
      desc: 'Ideal for growing businesses with advanced needs',
      features: ['Up to 500 members', 'Automated claims + fraud detection', 'Priority support', 'Advanced API + Webhooks', 'Custom reporting + Analytics', 'White-label options'],
      popular: true
    },
    {
      name: 'Enterprise',
      price: { monthly: 'Custom', yearly: 'Custom' },
      desc: 'For large organizations with complex requirements',
      features: ['Unlimited members', 'Full platform customization', 'Dedicated account manager', 'SLA guarantees', 'On-premise deployment options', 'Custom integrations'],
      popular: false
    }
  ];

  return (
    
    <div className="plans-page">
      {/* Header */}
      <Header />
      <header className="page-header bg_cover" style={{ backgroundImage: 'linear-gradient(rgba(238, 173, 83, 0.7), #F89423), url(/assets/images/home-one/hero/hero-bg.jpg)' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center pt-100 pb-100">
              <h1 className="text-white mb-3">Flexible HMO Plans</h1>
              <p className="text-white-50 lead">Choose the perfect plan for your business needs</p>
              {/* <Link to="/" className="theme-btn style-two mt-4">Back to Home</Link> */}
            </div>
          </div>
        </div>
      </header>

     

     {/* <Products /> */}
     <PlanCategories/>
       <Footer/>
    </div>
  );
};

export default Plans;